import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { LoadingFallback } from './LoadingFallback';
import { useProfile } from '@/hooks/use-queries';

interface ProtectedRouteProps {
  children: ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { user, loading } = useAuth();
  const location = useLocation();

  // Check if user has completed onboarding using standardized useProfile hook
  const { data: profile, isLoading: profileLoading } = useProfile(user?.id);

  if (loading || profileLoading) {
    return <LoadingFallback />;
  }

  if (!user) {
    return <Navigate to="/auth" replace />;
  }

  // Handle undefined profile state during race condition
  if (!profile) {
    return <LoadingFallback />;
  }

  // Redirect to onboarding if not completed (except on onboarding page itself)
  if (!profile.onboarded && location.pathname !== '/onboarding') {
    return <Navigate to="/onboarding" replace />;
  }

  return <>{children}</>;
}
